import moment from 'moment';

Vue.component('response', {
    props: ['quizzes', 'quote-id'],

    data () {
        return {
            quiz: null,

            loading: false,

            currentQuestion: 0,

            questions: [],

            responses: [],

            response: null,

            showConfirmation: false,

            complete: false,

            tab: 'new',

            modalLoading: false,

            activeResponse: []
        };
    },

    mounted () {
        this.getResponses();
    },

    methods: {
        setTab (tab) {
            this.tab = tab;
        },

        getResponses () {
            this.loading = true;

            axios.get('/api/questionnaire/responses/' + this.quoteId).then((response) => {
                this.quizResponses = response.data;
                this.loading = false;
            });
        },

        viewResponse (id) {
            this.modalLoading = true;

            $('#view-response').modal('show');

            axios.get('/api/questionnaire/get_response/' + id).then((response) => {
                this.activeResponse = response.data;
                this.modalLoading = false;
            });
        },

        getQuiz () {
            if (this.quiz != null) {
                this.loading = true;

                axios.get('/api/questionnaire/get_questions/' + this.quiz).then((response) => {
                    this.questions = response.data;
                    this.loading = false;
                });
            }
        },

        prev () {
            if (this.questions[this.currentQuestion - 1] != undefined) {
                this.currentQuestion--;

                this.response = this.responses[this.currentQuestion].answer;
            }
        },

        next () {
            this.responses[this.currentQuestion] = {
                answer: this.response,
                id: this.questions[this.currentQuestion].id
            };

            if (this.questions[this.currentQuestion + 1] != undefined) {
                this.currentQuestion++;
                this.response = this.responses[this.currentQuestion] != undefined ? this.responses[this.currentQuestion].answer : null;
            } else {
                this.showConfirmation = true;
            }
        },

        handleDateSelected (e) {
            this.response = e;
        },

        goBack () {
            this.showConfirmation = false;
            this.currentQuestion = 0;
            this.response = this.responses[this.currentQuestion] != undefined ? this.responses[this.currentQuestion].answer : null;
        },

        submit () {
            this.processing = true;

            axios.post('/api/questionnaire/response/' + this.quiz + '?quote_id=' + this.quoteId, this.responses).then((response) => {
                this.processing = false;
                this.complete = true;
                this.getResponses();
            });
        }
    },

    computed: {
        canGoNext() {
            return this.questions[this.currentQuestion].required && this.response == null ? false : true;
        }
    },

    filters: {
        date (value) {
            return value != null ? moment(value).format("DD-MM-YYYY HH:mm") : value;
        }
    }
});